import React from 'react';

interface MinimalListEditorProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
}

const MinimalListEditor: React.FC<MinimalListEditorProps> = ({ value, onChange, placeholder }) => {
  const lines = value.split('\n');

  return (
    <div className="minimal-list-editor">
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || 'Use new lines and start lines with "-" for list items'}
        rows={8}
        className="form-input textarea"
      />
      <div className="list-preview">
        {(() => {
          const blocks: React.ReactNode[] = [];
          let currentList: string[] = [];

          const flushList = () => {
            if (currentList.length) {
              const ulIndex = blocks.length;
              blocks.push(
                <ul key={`ul-${ulIndex}`}>
                  {currentList.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              );
              currentList = [];
            }
          };

          lines.forEach((raw, idx) => {
            const trimmed = raw.trim();
            if (trimmed.startsWith('-')) {
              currentList.push(trimmed.replace(/^-/,'').trim());
            } else {
              flushList();
              // preserve paragraphs (including empty lines for spacing)
              blocks.push(
                <p key={`p-${idx}`}>{raw}</p>
              );
            }
          });
          flushList();
          return <div className="plain-text">{blocks}</div>;
        })()}
      </div>
    </div>
  );
};

export default MinimalListEditor;
